import React, { useState, useEffect, useRef } from "react"
import PropTypes from 'prop-types'
import { Link, useNavigate } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
import moment from "moment"
import { getNotifications, markNotificationRead, markAllNotificationsRead } from "../../../helpers/fakebackend_helper"

//i18n
import { withTranslation } from "react-i18next"

const NotificationDropdown = props => {
  const [menu, setMenu] = useState(false)
  const [notifications, setNotifications] = useState([])
  const [unreadCount, setUnreadCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const pollingInterval = useRef(null)
  const navigate = useNavigate()

  const fetchNotifications = async () => {
    try {
      const response = await getNotifications({ per_page: 5 })
      if (response && response.data) {
        setNotifications(response.data)
        // Count locally for responsiveness, though backend might provide it
        const unread = response.data.filter(n => !n.read_at).length
        setUnreadCount(unread)
      }
    } catch (error) {
      console.error("Failed to fetch notifications", error)
    }
  }

  useEffect(() => {
    fetchNotifications()

    // Real-time "Lite": Poll every 30 seconds
    pollingInterval.current = setInterval(() => {
      fetchNotifications()
    }, 30000)

    return () => {
      if (pollingInterval.current) {
        clearInterval(pollingInterval.current)
      }
    }
  }, [])

  const handleMarkAllRead = async () => {
    try {
      await markAllNotificationsRead()
      fetchNotifications()
    } catch (error) {
      console.error("Failed to mark all as read", error)
    }
  }

  const handleNotificationClick = async (notification) => {
    if (!notification.read_at) {
      try {
        await markNotificationRead(notification.id)
        fetchNotifications()
      } catch (error) {
        console.error("Failed to mark read", error)
      }
    }

    if (notification.data.action_url) {
      navigate(notification.data.action_url)
    }
    setMenu(false)
  }

  const getIcon = (type) => {
    switch (type) {
      case 'success': return 'mdi-check-circle-outline text-success'
      case 'warning': return 'mdi-alert-outline text-warning'
      case 'danger': return 'mdi-alert-circle-outline text-danger'
      default: return 'mdi-information-outline text-info'
    }
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block ms-1"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon waves-effect"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="ti-bell"></i>
          {unreadCount > 0 && (
            <span className="badge text-bg-danger rounded-pill">{unreadCount}</span>
          )}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 shadow-lg border-0" style={{ borderRadius: '12px' }}>
          <div className="p-3 border-bottom bg-light" style={{ borderTopLeftRadius: '12px', borderTopRightRadius: '12px' }}>
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0 font-size-15 fw-semibold"> {props.t("Notifications")} </h6>
              </Col>
              <Col className="col-auto">
                <Link to="#" onClick={handleMarkAllRead} className="small text-primary">
                  {props.t("Mark all as read")}
                </Link>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ maxHeight: "300px" }}>
            {notifications.length > 0 ? (
              notifications.map((notification, index) => (
                <div
                  key={index}
                  className={`text-reset notification-item p-3 border-bottom ${!notification.read_at ? 'bg-light-subtle' : ''}`}
                  onClick={() => handleNotificationClick(notification)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-start">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-xs">
                        <span className="avatar-title bg-white rounded-circle border">
                          <i className={`mdi ${getIcon(notification.data.type)} font-size-18`}></i>
                        </span>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <h6 className="mt-0 mb-1 font-size-14">{notification.data.title}</h6>
                      <div className="text-muted font-size-13">
                        <p className="mb-1 text-truncate">{notification.data.message}</p>
                        <p className="mb-0 small"><i className="mdi mdi-clock-outline me-1"></i> {moment(notification.created_at).fromNow()}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="p-4 text-center text-muted">
                <i className="mdi mdi-bell-off-outline display-4"></i>
                <p className="mt-2 mb-0">{props.t("No notifications yet")}</p>
              </div>
            )}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 text-center py-2"
              to="#"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>
              {" "}
              {props.t("View all")}{" "}
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any
}